'use client';
import './styles/default.scss';

type ExclusivePreLaunchLogoProps = {
    logoUrl?: string;
    isEarlyAccess?: boolean;
};

export const ExclusivePreLaunchLogo: React.FC<ExclusivePreLaunchLogoProps> = ({ logoUrl, isEarlyAccess }) => {
    if (!logoUrl) {
        return null;
    }

    return (
        <div
            className={`exclusive-pre-launch__logo--container${isEarlyAccess ? ' exclusive-pre-launch__logo--container--early-access' : ''}`}>
            <img src={logoUrl} alt="Exclusive game logo" className="exclusive-pre-launch__logo--image" />
        </div>
    );
};
